/**
 * @description 繳費轉帳代碼 (enum)
 */
export enum PaymentTransCodesEnum {
  /** 授權 */
  Authorize = '00',
  /** 取消授權 */
  CancelAuthorize = '01',
  /** 卡號確認交易 */
  Confirm = '90'
}
